import { useNavigateWithParams } from '@experiences/util';
import { Box } from '@mui/material';
import React from 'react';

import { routePaths } from '../../../../common/constants/routePaths';
import type { StepComponentProps } from '../../constants';
import { GovernancePolicyStepNavigation } from '../../subcomponent/GovernancePolicyStepNavigation';

export const GovernancePolicyCreateFinishStep: React.FC<StepComponentProps> = ({ onBack }) => {
    const navigate = useNavigateWithParams();

    const handleFinish = () => {
        navigate(routePaths.adminGovernance);
    };

    const handleBack = () => {
        if (onBack) {
            onBack();
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'space-between',
            }}
            data-cy='governance-policy-create-start-step'>
            {/* TODO: Add Review policy configuration */}
            Placeholder

            <GovernancePolicyStepNavigation
                onNext={handleFinish}
                onBack={handleBack}
                backLabel="Back"
                nextLabel="Save"
            />
        </Box>
    );
};
